module.exports = __webpack_public_path__ + "static/media/create_branch_6.5b1f0b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/tutorials/create_branch/create_branch_6.png
// module id = 2232
// module chunks = 0